import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { AuthGuard } from '../guards/auth.guard';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../user/user.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ConfigurationService } from '../shared/configuration.service';
import { SettingsService } from '../settings/settings.service';
import { AnalyticsService } from '../analytics/analytics.service';
@Component({
    selector: 'app-get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.scss'],
    providers: [AuthGuard, SettingsService, CustomValidatorsService],
    // encapsulation: ViewEncapsulation.None

})
export class GetStartedComponent implements OnInit {
     isLoggedIn = true;
     processing = false;
    constructor(
        private router: Router,
        private userService: UserService,
        private _configuration: ConfigurationService,
        private _analyticsService: AnalyticsService
    ) { }


    ngOnInit() {
                // this.userService.getMyEmail().subscribe(email => {
                // if (email){this.isLoggedIn = true;
                //   this._analyticsService.initIntercom(email, email);
                //  } });
        //    }
      //  })
      const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove();
    }
    }

    onProcessing(event){

      if (event === 'done'){
      this.processing = true;
      } else {
        this.processing = false;
      }
    }
    OnSaved(registryName) {

     //   window.location.href = this._configuration.registryUrl.replace("{$registry}", registryName);
    }

}



// WEBPACK FOOTER //
// ./src/app/get-started/get-started.component.ts